<template>
  <list-module
    :index="index"
    :data="moduleData"
    :isEditMode="isEditMode"
  >
    <div class="text-module-body"><slot></slot></div>
  </list-module>
</template>

<script>
import ListModule from './ListModule.vue'
export default {
  components: {
    'list-module': ListModule
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    moduleData () {
      const value = this.$store.getters['api/ranch/PublicQa/qas']
      return {
        name: '公开提问',
        icon: 'icon-pr_phone_icon_answer_small',
        icon_body: this.isMobile ? null : 'answer_big',
        moreText: '',
        value
      }
    }
  },
  mounted () {
    this.$store.dispatch('api/ranch/PublicQa/load')
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/containers/module/PublicQaModule.vue